<template>
  <b-row>
    <b-col>
      <b-form-input
        v-model="simpleLimit"
        placeholder="Limit"
        type="number"
        min="0"
        :id="id + '-limit'"
        data-trigger="hover"
        :disabled="currentUser.id !== 1"
      ></b-form-input>
      <b-tooltip :target="id + '-limit'" triggers="hover"
        >Clicks count</b-tooltip
      >
    </b-col>
    <b-col>
      <b-form-input
        v-model="periodHumanValue"
        placeholder="Period value"
        type="number"
        min="0"
        :id="id + '-period'"
        data-trigger="hover"
        :disabled="currentUser.id !== 1"
      ></b-form-input>
      <b-tooltip :target="id + '-period'" triggers="hover">Period</b-tooltip>
    </b-col>
    <b-col>
      <b-form-select
        v-model="periodHumanDuration"
        :options="periodsArray"
        label="Period Duration"
        outlined
        :id="id + '-duration'"
        data-trigger="hover"
        :disabled="currentUser.id !== 1"
      ></b-form-select>
      <b-tooltip :target="id + '-duration'" triggers="hover"
        >Period duration</b-tooltip
      >
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    params: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      times: {
        minutes: 60,
        hours: 3600,
        days: 84600,
        weeks: 604800,
        months: 2419200
      },
      period: 0,
      periodsArray: [
        {
          text: "Months",
          value: "months"
        },
        {
          text: "Weeks",
          value: "weeks"
        },
        {
          text: "Days",
          value: "days"
        },
        {
          text: "Hours",
          value: "hours"
        },
        {
          text: "Minutes",
          value: "minutes"
        }
      ],
      periodHumanValue: 1,
      periodHumanDuration: "days"
    };
  },
  mounted() {
    this.period = this.params.period;
    this.calcValue();
    this.calcDuration();
  },
  watch: {
    periodHumanValue: function(newValue) {
      this.params.period =
        this.times[this.periodHumanDuration] * parseInt(newValue);
      this.$emit("change");
    },
    periodHumanDuration: function(newValue) {
      this.params.period =
        this.times[newValue] * parseInt(this.periodHumanValue);
      this.$emit("change");
    }
  },
  methods: {
    calcValue() {
      const period = parseInt(this.period);
      let value = 0;
      let testValue = 0;

      for (let key in this.times) {
        testValue = Math.floor(period / this.times[key]);
        if (testValue > 0) {
          value = testValue;
        }
      }

      this.periodHumanValue = value;
    },
    calcDuration() {
      const period = parseInt(this.period);
      let value = null;

      for (let key in this.times) {
        if (Math.floor(period / this.times[key]) > 0) {
          value = key;
        }
      }

      this.periodHumanDuration = value;
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    simpleLimit: {
      get() {
        return this.params.limit;
      },
      set(newValue) {
        this.params.limit = Math.abs(parseInt(newValue));
        this.$emit("change");
      }
    }
  }
};
</script>

<style scoped>
.left-padding {
  padding-left: 20px;
}
</style>
